import { render } from "./TaxDetails.vue?vue&type=template&id=729c2574"
import script from "./TaxDetails.vue?vue&type=script&lang=js"
export * from "./TaxDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__